// extracted by mini-css-extract-plugin
module.exports = {"shareItem":"Share_shareItem__I5pJ9","icon":"Share_icon__CBXf_"};